import createStore from './createStore';
import { initActions, networkActions, nucleusConstants } from '@lifesize/nucleus';
import { ClientTypes } from '@lifesize/constants';
import * as nucleus from '@lifesize/nucleus';
import { VideoElementId } from './constants/ElementIds';
import getApiDomain from 'utils/getApiDomain';

export default async function bootstrap() {

  const nucleusInitOptions = {
    callHistoryEnabled: false,
    cssEnabled: false,
    clientInfo: {
      clientType: ClientTypes.DASH_PRESENTER,
      version: process.env.REACT_APP_VERSION
    },
    videoConstraints: {
      width: { min: 1280, ideal: 1920, max: 1920 },
      height: { min: 720, ideal: 1080, max: 1080 }
    },
    directMediaEnabled: true,
    galaxyCallsEnabled: false,
    isDisplay: false,
    loadContactsOnLogin: false,
    localPrimaryElementIds: [VideoElementId.localPrimary],
    localSecondaryElementIds: [VideoElementId.localSecondary],
    platform: navigator.platform === 'Win32' ? nucleusConstants.PLATFORM_WINDOWS : nucleusConstants.PLATFORM_OSX,
    psemsEnabled: false,
    remotePrimaryElementIds: [VideoElementId.remotePrimary],
    remoteSecondaryElementIds: [VideoElementId.remoteSecondary],
    version: process.env.REACT_APP_VERSION || '0.0.1',
    environment: getApiDomain()
  };

  const store = await createStore();
  (window as any).lifesize = {
    store,
    nucleus
  };

  await store.dispatch(initActions.initialize(nucleusInitOptions));
  await store.dispatch(navigator && navigator.onLine ? networkActions.online() : networkActions.offline());

  return store;
}



// WEBPACK FOOTER //
// ./src/bootstrap.ts